import { digitsOnly } from '../utils/phone';

// Status transitions allowed by admin actions.
// Returns the list of statuses that the admin can move TO from the current status.
// Terminal statuses (completed/cancelled/rejected) return [] — only permanent
// delete is allowed from those, and that path lives outside this map.
const TRANSITIONS = {
  pending: ['confirmed', 'rejected'],
  confirmed: ['completed', 'cancelled'],
  completed: [],
  cancelled: [],
  rejected: [],
};

export function getNextStatuses(currentStatus) {
  return TRANSITIONS[currentStatus] || [];
}

// Search across customerName (substring) and customerPhone (digits-only).
// Phone normalization delegates to digitsOnly from utils/phone for consistency
// with the rest of the codebase (handles E.164 +82 prefix swap correctly).
// Empty query returns the full list unchanged.
export function filterBookings(bookings, query) {
  if (!query || !query.trim()) return bookings;
  const trimmed = query.trim();
  const queryDigits = digitsOnly(trimmed);
  const isDigitSearch = queryDigits.length >= 2;
  const nameNeedle = trimmed.toLowerCase();

  return bookings.filter(b => {
    const name = (b.customerName || '').toLowerCase();
    if (name.includes(nameNeedle)) return true;
    if (isDigitSearch) {
      const bookingPhone = digitsOnly(b.customerPhone);
      if (bookingPhone.includes(queryDigits)) return true;
    }
    return false;
  });
}

// Sort a copy of `bookings` by `key` in `direction` (asc|desc).
// Null/undefined values always go to the end regardless of direction.
// Korean strings use localeCompare('ko-KR') for natural ordering.
// When sorting by `date`, `time` is used as a tie-breaker following the
// same direction as the primary sort.
export function sortBookings(bookings, key, direction) {
  const sign = direction === 'desc' ? -1 : 1;
  const compare = (av, bv, s) => {
    const aNull = av === null || av === undefined;
    const bNull = bv === null || bv === undefined;
    if (aNull && bNull) return 0;
    if (aNull) return 1;
    if (bNull) return -1;
    if (typeof av === 'string' && typeof bv === 'string') {
      return av.localeCompare(bv, 'ko-KR') * s;
    }
    if (av < bv) return -1 * s;
    if (av > bv) return 1 * s;
    return 0;
  };
  return [...bookings].sort((a, b) => {
    const primary = compare(a[key], b[key], sign);
    if (primary !== 0) return primary;
    if (key === 'date') {
      return compare(a.time, b.time, sign);
    }
    return 0;
  });
}
